import {Constant} from "../common/constant";
import {FilterType} from "../enums/filter.type";

export class FilterUtil {
  public static AttributesFilters = [
    {
      Type: FilterType.STRING,
      Field: 'AttributeTitle',
      Title: 'Title',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.STRING,
      Field: 'AttributeCode',
      Title: 'Code',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.SELECT,
      Field: 'AttributeTypeId',
      Value: undefined,
      ValueId: 'AttributeTypeId',
      AutoSelectLatest: false,
      Controller: 'attributeTypes',
      DisplayKey: 'Title,Type',
      FieldName: 'AttributeTypeId',
      IsMultiple: false,
      IsSearchable: true,
      Method: 'get',
      Microservice: Constant.FOOD_SHOP,
      OrderByField: 'AttributeTypeId',
      OrderByType: 'ASC',
      ProtocolMethod: 'POST',
      Required: false,
      SearchOnKey: 'Title,Type',
      SelectedOptions: [],
      Title: 'AttributeType',
      Version: 'v1'
    }
  ];
  public static AttributeTypesFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }
  ];
  public static DomainsFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }
  ];
  public static CategoriesFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.DROP_DOWN,
      Field: 'IsActive',
      Value: undefined,
      ValueId: 'Value',
      AutoSelectLatest: false,
      DisplayKey: 'Title',
      FieldName: 'Value',
      IsMultiple: false,
      IsSearchable: false,
      Required: false,
      SearchOnKey: 'Title',
      Options: [{
        Title: 'فعال',
        Value: 'True'
      }, {
        Title: 'غیرفعال',
        Value: 'False'
      }],
      SelectedOptions: [],
      Title: 'Status'
    }
  ];
  public static SlideShowsFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }
  ];
  public static UsersFilters = [
    {
      Type: FilterType.STRING,
      Field: 'FirstName',
      Title: 'FirstName',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'LastName',
      Title: 'LastName',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'MobileNumber',
      Title: 'MobileNumber',
      Required: false,
      Value: undefined
    }
  ];
  public static DeliveryMethodsFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }
  ];
  public static RolesFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }
  ];
  public static ProductsFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Title',
      Title: 'Title',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.SELECT,
      Field: 'CategoryId',
      Value: undefined,
      ValueId: 'CategoryId',
      AutoSelectLatest: false,
      Controller: 'categories',
      DisplayKey: 'Title,CategoryId',
      FieldName: 'CategoryId',
      IsMultiple: false,
      IsSearchable: true,
      Method: 'get',
      Microservice: Constant.FOOD_SHOP,
      OrderByField: 'ModifyDate',
      OrderByType: 'ASC',
      ProtocolMethod: 'POST',
      Required: false,
      SearchOnKey: 'Title,CategoryId',
      SelectedOptions: [],
      Title: 'Category',
      Version: 'v1'
    }
  ];
  public static UserSelectFilter = [
    {
      Type: FilterType.STRING,
      Field: 'FirstName',
      Title: 'FirstName',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.STRING,
      Field: 'LastName',
      Title: 'LastName',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.STRING,
      Field: 'NationalCode',
      Title: 'NationalCode',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.STRING,
      Field: 'MobileNumber',
      Title: 'MobileNumber',
      Required: false,
      Value: undefined
    }, {
      Type: FilterType.STRING,
      Field: 'Email',
      Title: 'Email',
      Required: false,
      Value: undefined
    }
  ];
  public static FactorsFilters = [];
  public static OrdersFilters = [
    {
      Type: FilterType.STRING,
      Field: 'FactorId',
      Title: 'FactorId',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'User.FirstName',
      Title: 'FirstName',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'User.LastName',
      Title: 'LastName',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'User.MobileNumber',
      Title: 'MobileNumber',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.DROP_DOWN,
      Field: 'Status',
      Value: undefined,
      ValueId: 'Value',
      AutoSelectLatest: false,
      DisplayKey: 'Title',
      FieldName: 'Value',
      IsMultiple: false,
      IsSearchable: false,
      Required: false,
      SearchOnKey: 'Title',
      Options: [{
        Title: 'ثبت سفارش',
        Value: 'SUBMIT'
      }, {
        Title: 'در انتظار پرداخت',
        Value: 'PENDING_PAYMENT'
      }, {
        Title: 'بررسی و تایید سفارش',
        Value: 'PROGRESSING'
      }, {
        Title: 'در حال آماده سازی',
        Value: 'PREPARATION'
      }, {
        Title: 'خروج از آشپزخانه',
        Value: 'PROCESSING_CENTER'
      }, {
        Title: 'تحویل به مأمور ارسال',
        Value: 'DELIVERY_DISPATCHER'
      }, {
        Title: 'تحویل به مشتری',
        Value: 'DELIVERED'
      }, {
        Title: 'لغو شده',
        Value: 'CANCELED'
      }, {
        Title: 'لغو شده توسط سیستم',
        Value: 'CANCELED_BY_SYSTEM'
      }],
      SelectedOptions: [],
      Title: 'Status'
    },
    {
      Type: FilterType.SELECT,
      Field: 'BranchId',
      Value: undefined,
      ValueId: 'BusinessId',
      AutoSelectLatest: false,
      Controller: 'businesses',
      DisplayKey: 'Title',
      FieldName: 'BusinessId',
      IsMultiple: false,
      IsSearchable: true,
      Method: 'getBranches',
      Microservice: Constant.FOOD_SHOP,
      OrderByField: 'BusinessId',
      OrderByType: 'ASC',
      ProtocolMethod: 'POST',
      Required: false,
      SearchOnKey: 'Title',
      SelectedOptions: [],
      Title: 'Branch',
      Version: 'v1'
    }
  ];
  public static CommentsFilters = [
    {
      Type: FilterType.STRING,
      Field: 'Comment',
      Title: 'متن نظر',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'User.FirstName',
      Title: 'نام کاربر',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'User.LastName',
      Title: 'نام خانوادگی کاربر',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.STRING,
      Field: 'User.MobileNumber',
      Title: 'شماره موبایل',
      Required: false,
      Value: undefined
    },
    {
      Type: FilterType.SELECT,
      Field: 'Status',
      Value: undefined,
      ValueId: 'Status',
      AutoSelectLatest: false,
      Controller: '',
      DisplayKey: 'label',
      FieldName: 'Status',
      IsMultiple: false,
      IsSearchable: false,
      Method: '',
      Microservice: '',
      OrderByField: '',
      OrderByType: 'ASC',
      ProtocolMethod: 'POST',
      Required: false,
      SearchOnKey: '',
      SelectedOptions: [
        {
          value: 'AWAITING_APPROVAL',
          label: 'در انتظار تایید'
        },
        {
          value: 'APPROVED',
          label: 'تایید شده'
        },
        {
          value: 'REJECTED',
          label: 'رد شده'
        }
      ],
      Title: 'وضعیت نظر',
      Version: 'v1'
    },
    {
      Type: FilterType.DATE,
      Field: 'CreateDate',
      Title: 'تاریخ ثبت نظر',
      Required: false,
      Value: undefined
    }
  ];
}
